// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__c1APG","inputDescription":"styles_inputDescription__161Br"};